import http from "../../backend/http.js";

async function getCurrency(id) {
  try {
    const response = await http.get(`crm/currencies/${id}`);
    return {
      id: response.data.id,
      title: response.data.title,
      code: response.data.code,
    };
  } catch (err) {
    throw err;
  }
}

async function updateCurrency(id, data) {
  try {
    const response = await http.put(`crm/currencies/${id}`, data);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createCurrency(data) {
  try {
    const response = await http.post("crm/currencies", data);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getCurrencies(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get(
      `crm/currencies?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

export { getCurrency, updateCurrency, getCurrencies, createCurrency };